import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Stack from '@eversports/klimt-primitives/legacy/Stack'

import { VenueType } from '../../../../App.types'
import { Localized } from '../../../../localization/react'
import { Trainer } from '../../ActivityDetails.types'
import ContentWrapper from '../../components/ContentWrapper'
import { getTrainerTranslationKey } from '../../helpers/get-trainer-translation-key'

import TrainerContent from './TrainerContent'

interface Props {
  trainer: Trainer
  venueType: VenueType | null
}

const SingleTrainer = ({ trainer, venueType }: Props) => {
  const trainerHeadingKey = getTrainerTranslationKey(venueType)
  const { education, description } = trainer

  // Don't show if there's no descriptive info.
  // In that case, we will show just the teacher's name in the sidebar instead.
  const hideSectionOnDesktop = !description && !education

  return (
    <ContentWrapper sx={{ display: { xs: 'flex', md: hideSectionOnDesktop ? 'none' : 'flex' } }}>
      <Stack gap={4}>
        <Heading is="h2" color="midnight">
          <Localized id={trainerHeadingKey} params={{ trainerCount: 1 }} />
        </Heading>
        <TrainerContent trainer={trainer} />
      </Stack>
    </ContentWrapper>
  )
}

export default SingleTrainer
